/**
 * describeApiError — a thrown API error → a line a human can act on.
 *
 * `api.request` builds its Error from the response's `detail`, and FastAPI
 * answers many of ours as a STRUCTURED dict (`{code, message}`) — `new
 * Error(dict)` flattens that to "[object Object]", which is what several
 * surfaces used to show the user. So: prefer the structured message, keep the
 * status (402 = this account has no credits, 401 = signed out), and never
 * render a raw object.
 *
 * Its own module, with no imports: constructing the api client needs a browser
 * (localStorage), and formatting an error must work anywhere — including in a
 * test that mocks the client away.
 */
export function describeApiError(e) {
  if (!e) return 'unknown error';
  if (typeof e === 'string') return e;
  const status = e.status || e.response?.status || null;
  const detail = e.detail && typeof e.detail === 'object' ? e.detail : null;
  let text = detail?.message || detail?.code || e.message || '';
  if (!text || text === '[object Object]') {
    try { text = JSON.stringify(e.detail ?? e); } catch { text = String(e); }
  }
  return status ? `${status} · ${text}` : text;
}

export default describeApiError;
